import { useMemo, useState, useContext, useRef, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";

// MindPlus components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDEditor from "components/MDEditor";
import MDInput from "components/MDInput";
import MDDropzone from "components/MDDropzone";
import MDButton from "components/MDButton";

// NewProduct page components
import FormField from "components/FormField";
import { Card } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataContext } from "context/dataContext";
import { v4 as uuidv4 } from "uuid";

function ProgramInfo() {
  const navigate = useNavigate();

  const imageRef = useRef();
  const soundRef = useRef();

  const { dataState, createBreatheApi } = useContext(DataContext);

  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [inhale, setInhale] = useState(0);
  const [exhale, setExhale] = useState(0);
  const [hold, setHold] = useState(0);
  const [category, setCategory] = useState("Focus");
  const [tags, setTags] = useState([]);
  const [excerpt, setExcerpt] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("Free");
  const [duration, setDuration] = useState("");
  const [price, setPrice] = useState(0);
  const [is_enable, setIsEnable] = useState(true);

  const [files, setFiles] = useState(null);
  const [image, setImage] = useState(null);

  const convertToSlug = (str) => {
    //replace all special characters | symbols with a space
    str = str.replace(/[`~!@#$%^&*()_\-+=\[\]{};:'"\\|\/,.<>?\s]/g, " ").toLowerCase();

    // trim spaces at start and end of string
    str = str.replace(/^\s+|\s+$/gm, "");

    // replace space with dash/hyphen
    str = str.replace(/\s+/g, "-");

    return str;
  };

  const uuidvNumbers = () => {
    const uuid = uuidv4();
    const uuidFinal = uuid.replace(/\D/g, "").slice(0, 12);
    return Number(uuidFinal);
  };

  const handleNameChange = (e) => {
    // var productName = e.target.value;
    // productName = productName.replace(/^\s+|\s+$/gm, "");

    setName(e.target.value);
    var slug = convertToSlug(e.target.value);

    setSlug(slug);
  };

  const handleInhaleChange = (e) => {
    setInhale(e.target.value);
  };

  const handleExhaleChange = (e) => {
    setExhale(e.target.value);
  };

  const handleHoldChange = (e) => {
    setHold(e.target.value);
  };

  const handleDescription = (e) => {
    setDescription(e.target.value);
  };

  const handleExcerpt = (e) => {
    setExcerpt(e.target.value);
  };

  const handleCategory = (event, value) => {
    setCategory(value);
  };

  const handleTags = (event, value) => {
    setTags(value);
  };

  const handleType = (event, value) => {
    setType(value);
  };

  const handelActive = (event, value) => {
    setIsEnable(value);
  };

  const handlePrice = (e) => {
    setPrice(e.target.value);
  };

  const handleNext = () => {
    // navigate to add sessions page

    var breathe_id = uuidvNumbers();

    // uploadProgramImageApi({
    //   id: breathe_id,
    //   image: files,
    // }).then((res) => {
    //   //console.log("getSingleProgramApi", res);
    //   if (res.success) {
    //     console.log("Image Uploaded");
    //   } else {
    //     console.log("Something went wrong");
    //   }
    // });

    const form = new FormData();
    form.append("id", breathe_id);
    form.append("program", breathe_id);
    form.append("name", name);
    form.append("inhale", inhale);
    form.append("exhale", exhale);
    form.append("hold", hold);
    form.append("type", type);
    form.append("slug", slug);
    form.append("category", category);
    form.append("excerpt", excerpt);
    form.append("description", description);
    form.append("tags", tags);
    form.append("is_enable", is_enable);
    form.append("image", image);
    form.append("created_on", new Date());

    createBreatheApi({
      form: form,
    }).then((res) => {
      if (res.success) {
        console.log("Breathe Added", res);
        navigate(`/breathe/breathe-list/`);
      } else {
        console.log("Something went wrong");
      }
    });
  };

  const readImage = (image) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      // The image content is available in event.target.result
      const imageContent = event.target.result;
      setFiles(imageContent);
      console.log("File content:");
    };

    reader.onerror = (error) => {
      console.error("Error reading image:", error);
    };

    // Choose the appropriate reading method based on the image type and desired output:
    // reader.readAsText(image); // Reads the image as a plain text string
    reader.readAsDataURL(image); // Reads the image as a data URL (useful for images)
    // reader.readAsArrayBuffer(image); // Reads the image as an ArrayBuffer
    // reader.readAsText(file); // Example: reading as text
  };

  const handleImage = (e) => {
    console.log("file", e.target.files[0]);
    setImage(e.target.files[0]);
    var file = e.target.files[0];
    console.log(file);
    if (file) {
      // Proceed to read the file
      readImage(file);
    }
  };

  const setPlaceholderImage = () => {
    setFiles("https://placehold.co/400x300");
  };

  useEffect(() => {
    setPlaceholderImage();
  }, []);

  return (
    <MDBox mt={3}>
      <Grid container spacing={3} pt={3}>
        <Grid item xs={12} sm={4}>
          <Card sx={{ overflow: "visible", p: 2 }}>
            <MDBox>
              <MDTypography variant="h5">Image</MDTypography>
              <MDBox mt={3}>
                <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <MDTypography
                    component="label"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    Breathe Image *
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <MDBox
                    component="img"
                    src={files}
                    alt={"Breathe Image"}
                    onError={setPlaceholderImage}
                    borderRadius="lg"
                    shadow="md"
                    width="100%"
                    height="100%"
                    position="relative"
                    zIndex={1}
                  />
                  <MDInput
                    type="file"
                    label="Image File"
                    variant="standard"
                    fullWidth
                    ref={imageRef}
                    onChange={handleImage}
                  />
                </MDBox>
              </MDBox>
            </MDBox>
          </Card>
        </Grid>

        <Grid item xs={12} sm={8} pt={7}>
          <Card sx={{ overflow: "visible", p: 2 }}>
            <MDTypography variant="h5">Breathe Infromation</MDTypography>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormField type="text" label="Name *" value={name} onChange={handleNameChange} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormField type="text" disabled label="Slug" value={slug} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormField
                  type="number"
                  label="Inhale (sec)"
                  value={inhale}
                  onChange={handleInhaleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormField
                  type="number"
                  label="Hold (sec)"
                  value={hold}
                  onChange={handleHoldChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormField
                  type="number"
                  label="Exhale (sec)"
                  value={exhale}
                  onChange={handleExhaleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <MDBox mb={3}>
                  <MDBox mb={2} display="inline-block">
                    <MDTypography
                      component="label"
                      variant="button"
                      fontWeight="regular"
                      color="text"
                      textTransform="capitalize"
                    >
                      Category *
                    </MDTypography>
                  </MDBox>
                  <Autocomplete
                    value={category}
                    onChange={handleCategory}
                    options={["Focus", "Relaxation", "Balance", "Sleep"]}
                    renderInput={(params) => <MDInput {...params} variant="standard" />}
                  />
                </MDBox>
              </Grid>

              <Grid item xs={12} sm={6}>
                <MDBox mb={3}>
                  <MDBox mb={2} display="inline-block">
                    <MDTypography
                      component="label"
                      variant="button"
                      fontWeight="regular"
                      color="text"
                      textTransform="capitalize"
                    >
                      Tags *
                    </MDTypography>
                  </MDBox>
                  <Autocomplete
                    multiple
                    value={tags}
                    onChange={handleTags}
                    options={["Focus", "Relaxation", "Balance", "Sleep"]}
                    renderInput={(params) => <MDInput {...params} variant="standard" />}
                  />
                </MDBox>
              </Grid>

              <Grid item xs={12} sm={6}>
                <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <MDTypography
                    component="label"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    Description&nbsp;&nbsp;
                    <MDTypography variant="caption" color="text">
                      (optional)
                    </MDTypography>
                  </MDTypography>
                </MDBox>
                <FormField
                  type="text"
                  multiline
                  value={description}
                  onChange={handleDescription}
                  label="Enter description here"
                />
                {/* <MDEditor value={editorValue} onChange={setEditorValue} /> */}
              </Grid>

              <Grid item xs={12} sm={6}>
                <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <MDTypography
                    component="label"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    Excerpt&nbsp;&nbsp;
                    <MDTypography variant="caption" color="text">
                      (*)
                    </MDTypography>
                  </MDTypography>
                </MDBox>
                <FormField
                  type="text"
                  multiline
                  value={excerpt}
                  onChange={handleExcerpt}
                  label="Enter excerpt here"
                />
                {/* <MDEditor value={editorValue} onChange={setEditorValue} /> */}
              </Grid>

              <Grid item xs={6} sm={3}>
                <MDBox mb={2} display="inline-block">
                  <MDTypography
                    component="label"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    textTransform="capitalize"
                  >
                    Type *
                  </MDTypography>
                </MDBox>
                <Autocomplete
                  defaultValue="Free"
                  options={["Free", "Premium", "Demo"]}
                  onChange={handleType}
                  renderInput={(params) => <MDInput {...params} variant="standard" />}
                />
                {type === "Premium" ? (
                  <Grid item xs={12} sm={12} mt={2}>
                    <FormField type="text" label="Price" value={price} onChange={handlePrice} />
                  </Grid>
                ) : (
                  <></>
                )}
              </Grid>
              <Grid item xs={6} sm={3}>
                <MDBox mb={2} display="inline-block">
                  <MDTypography
                    component="label"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    textTransform="capitalize"
                  >
                    Active *
                  </MDTypography>
                </MDBox>
                <Autocomplete
                  defaultValue={true}
                  onChange={handelActive}
                  options={[true, false]}
                  renderInput={(params) => <MDInput {...params} variant="standard" />}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} mt={2}>
              <MDButton mt={4} variant="gradient" color="primary" onClick={handleNext}>
                Next
              </MDButton>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default ProgramInfo;
